import 'init/1-polyfills';
import 'init/3-prelude';
import 'init/4-i18next';

window.alpha = true;

async function main() {
    const { renderApp } = await import('./App');
    renderApp();
}

main();
